import { render, staticRenderFns } from "./RequestStatusSelector.vue?vue&type=template&id=673485ea"
import script from "./RequestStatusSelector.vue?vue&type=script&lang=js"
export * from "./RequestStatusSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports